/** Function to change/replace a character or space in a string*/
/** Function always returns result in lowercase*/

const transformString = (text: string, valueToRemove: string, valueToReplace: string) => {
    let replacedText = text?.replaceAll(valueToRemove, valueToReplace)
    return replacedText?.toLowerCase()
}

export default transformString